// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23888%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Dashboard Layout */
.dashboard-container {
  display: flex;
  height: 100vh;
  font-family: 'Roboto', 'Segoe UI', sans-serif;
  background-color: #f7f9fc;
  color: #333;
  overflow: hidden;
}

/* Error Banner */
.error-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f44336;
  color: white;
  padding: 12px 20px;
  text-align: center;
  font-weight: 500;
  z-index: 9999;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from { transform: translateY(-100%); }
  to { transform: translateY(0); }
}

/* Loading Animation */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f7f9fc;
}

.loading-spinner {
  position: relative;
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid rgba(124, 193, 51, 0.2);
  border-radius: 50%;
  border-top-color: #7CC133;
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-container p {
  color: #555;
  font-size: 18px;
  font-weight: 500;
}

/* Sidebar Styling */
.sidebar {
  width: 250px;
  background: linear-gradient(145deg, #1e3a8a, #304da6);
  color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  transition: width 0.3s ease;
  overflow-y: auto;
}

.logo-container {
  padding: 25px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar .logo {
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  margin: 0;
  letter-spacing: 0.5px;
  color: white;
}

.sidebar-nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0;
}

.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  padding: 14px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  border-left: 4px solid transparent;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-item.active {
  background-color: rgba(255, 255, 255, 0.15);
  border-left-color: #7cc133;
}

.nav-icon {
  margin-right: 12px;
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.nav-text {
  font-size: 15px;
  font-weight: 500;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.logout-button {
  width: 100%;
  padding: 12px 0;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.logout-button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.logout-icon {
  margin-right: 8px;
  font-size: 16px;
}

/* Main Content Area */
.main-content {
  flex: 1 1;
  padding: 30px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.content-header h1 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

/* Search Bar */
.search-container {
  position: relative;
  min-width: 300px;
}

.search-input {
  width: 100%;
  padding: 10px 15px;
  padding-right: 40px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: #fff;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #888;
  pointer-events: none;
}

/* Data Card Styling */
.data-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.card-header {
  padding: 20px 25px;
  border-bottom: 1px solid #eaedf2;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.table-responsive {
  overflow-x: auto;
  padding-bottom: 10px; /* Add padding to prevent cut-off at bottom */
}

/* Data Table Styling */
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.data-table thead tr {
  background-color: #f8f9fd;
}

.data-table th {
  padding: 15px 20px;
  text-align: left;
  font-weight: 600;
  color: #495057;
  border-bottom: 1px solid #eaedf2;
}

.data-table td {
  padding: 15px 20px;
  border-bottom: 1px solid #eaedf2;
  color: #333;
}

.data-table tbody tr {
  transition: background-color 0.2s ease;
}

.data-table tbody tr:hover {
  background-color: #f8f9fd;
}

.no-results {
  text-align: center;
  padding: 30px;
  color: #666;
  font-style: italic;
}

/* Role Badge */
.role-badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: #e0f2ff;
  color: #0077cc;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
}

.status-pending {
  background-color: #fff8e0;
  color: #f59e0b;
}

.status-approved {
  background-color: #ecfdf5;
  color: #10b981;
}

.status-rejected {
  background-color: #fef2f2;
  color: #ef4444;
}

.status-passed {
  background-color: #ecfdf5;
  color: #10b981;
}

.status-failed {
  background-color: #fef2f2;
  color: #ef4444;
}

/* Action Buttons */

.action-cell {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start; 
}

.view-button, .checklist-button, .exam-button {
  display: inline-block;
  margin: 2px;
  width: 130px !important; /* Fixed width */
  height: 45px; /* Fixed height */
  line-height: 36px; /* Center text vertically */
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 5px; /* Reduced padding */
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 4px;
}

.view-button {
  background-color: #e0f2ff;
  color: #0077cc;
}

.view-button:hover {
  background-color: #d0e9ff;
}

.close-button {
  background-color: #f1f5f9;
  color: #64748b;
}

.close-button:hover {
  background-color: #e2e8f0;
}

.checklist-button {
  background-color: #fef9c3;
  color: #d97706;
}

.checklist-button:hover {
  background-color: #fef3c7;
}

.exam-button {
  background-color: #e0e7ff;
  color: #4f46e5;
}

.exam-button:hover {
  background-color: #d1d9ff;
}

.info-button {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background-color: #f1f5f9;
  cursor: pointer;
  transition: all 0.2s ease;
}

.info-button:hover {
  background-color: #e2e8f0;
}

/* Modal Styling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  margin: 0 auto; /* This helps with centering */
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease-out;
  position: relative; /* Ensure positioning context */
  left: 0; /* Reset any left positioning */
  transform: none; /* Reset any transforms */
}

@keyframes slideUp {
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #eaedf2;
}

.modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.modal-close-button {
  background: none;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-close-button:hover {
  background-color: #f1f5f9;
}

.modal-body {
  padding: 25px;
}

.detail-grid {
  display: grid;
  gap: 16px;
}

.detail-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 12px;
}

.detail-label {
  min-width: 120px;
  font-weight: 600;
  color: #64748b;
}

.detail-value {
  flex: 1 1;
  color: #333;
}


/* Document Overlay Fix */
.document-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
}

.document-overlay-content {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 900px;
  height: 90vh;
  overflow: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1001; /* Ensure content appears above overlay background */
  animation: slideUp 0.3s ease-out;
}

.document-overlay-close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #64748b;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1002;
  transition: all 0.2s ease;
}

.document-overlay-close-button:hover {
  background-color: #f1f5f9;
}

.document-overlay-header {
  padding: 25px;
  border-bottom: 1px solid #eaedf2;
}

.document-overlay-header h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.document-overlay-header p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.document-content-wrapper {
  padding: 20px;
  overflow: auto;
}

/* Print styles for document overlay */
@media print {
  @page {
    size: auto; 
    margin: 0; 
  }
  
  .dashboard-container, .sidebar, .main-content {
    display: none;
  }
  
  body {
    margin: 0;
    padding: 0;
  }
  
  body * {
    visibility: hidden;
  }
  
  .document-overlay-content, .document-overlay-content * {
    visibility: visible;
  }
  
  .document-overlay-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    max-width: none;
    box-shadow: none;
    overflow: visible;
    background: none;
    border-radius: 0;
    padding: 0;
  }

  .document-overlay-close-button, .document-overlay-header {
    display: none; 
  }
}



/* Animations for UI elements */
@keyframes pulseGlow {
  0% { box-shadow: 0 0 0 0 rgba(124, 193, 51, 0.4); }
  70% { box-shadow: 0 0 0 10px rgba(124, 193, 51, 0); }
  100% { box-shadow: 0 0 0 0 rgba(124, 193, 51, 0); }
}

.role-badge {
  animation: fadeIn 0.5s ease-out;
}

.status-badge {
  animation: fadeIn 0.5s ease-out;
}

/* Override for conflicting close-button class */
.action-button.close-button {
  background-color: #f1f5f9;
  color: #64748b;
}

.action-button.close-button:hover {
  background-color: #e2e8f0;
}

/* Subtle hover effects for rows */
.data-table tbody tr {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.data-table tbody tr:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 1;
  position: relative;
}

/* Add this media query at the bottom of your CSS file */
@media screen and (max-width: 768px) {
  .sidebar {
    width: 70px;  /* Reduce sidebar width on small screens */
  }
 
  .sidebar .logo {
    font-size: 16px;  /* Make logo text smaller */
  }
 
  .nav-text {
    display: none;  /* Hide nav text on small screens */
  }
 
  .nav-icon {
    margin-right: 0;  /* Remove margin since text is hidden */
  }
 
  .nav-item {
    justify-content: center;  /* Center the remaining icon */
    padding: 14px 10px;  /* Reduce padding */
  }
 
  .logout-button {
    justify-content: center;  /* Center logout icon */
  }
 
  .logout-icon {
    margin-right: 0;  /* Remove margin since text will be hidden */
  }
  
  /* Search container adjustments */
  .search-container {
    min-width: 200px;  /* Reduce minimum width on mobile */
    width: 100%;  /* Allow it to be responsive */
  }
 
  .search-input {
    padding: 8px 12px;  /* Smaller padding */
    padding-right: 30px;  /* Maintain space for search icon */
    font-size: 12px;  /* Smaller font size */
  }
 
  .search-icon {
    right: 10px;  /* Adjust icon position */
    font-size: 14px;  /* Smaller icon size */
  }
 
  /* Content header adjustments */
  .content-header {
    flex-direction: column;  /* Stack elements vertically on small screens */
    align-items: flex-start;  /* Align to left */
    gap: 15px;  /* Add space between elements */
  }
 
  .content-header h1 {
    font-size: 20px;  /* Smaller heading */
  }
  
  /* Action buttons for mobile view */
  .action-cell {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .view-button, .checklist-button, .exam-button {
    width: 100% !important;  /* Full width on mobile */
    margin: 2px 0;
    height: 38px;  /* Slightly smaller height */
    font-size: 12px;  /* Smaller font */
    line-height: 38px;  /* Match the height */
  }
}

/* Media query for iPad/tablet devices */
@media screen and (min-width: 769px) and (max-width: 1024px) {

  .table-container {
    padding-bottom: 12px; /* Add space for the scrollbar */
  }
  .sidebar {
    width: 180px;  /* Wider than mobile but narrower than desktop */
  }
 
  .sidebar .logo {
    font-size: 18px;
  }
 
  .nav-text {
    font-size: 14px;  /* Smaller text but still visible */
    display: block;
  }
 
  .nav-icon {
    margin-right: 8px;  /* Reduced margin */
  }
 
  .nav-item {
    padding: 12px 15px;
  }
 
  .search-container {
    min-width: 250px;
  }
 
  .main-content {
    padding: 20px;  /* Slightly reduced padding */
  }
 
  /* Table adjustments for iPad */
  .data-table th,
  .data-table td {
    padding: 12px 15px;  /* Reduced padding */
    font-size: 13px;  /* Slightly smaller font */
  }
 
  /* Action buttons adjustments for iPad - MATCHING MOBILE STYLE */
  .action-cell {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .view-button, .checklist-button, .exam-button {
    width: 100% !important;  /* Full width */
    margin: 2px 0;
    height: 38px;  /* Same height as mobile */
    font-size: 12px;  /* Same font size as mobile */
    line-height: 38px;  /* Match the height */
  }
 
  /* Modal adjustments */
  .modal-container {
    max-width: 550px;
  }
 
  .modal-body {
    padding: 20px;
  }
 
  /* Document overlay adjustments */
  .document-overlay-content {
    max-width: 800px;
  }
 
  .document-overlay-header {
    padding: 20px;
  }
 
  .document-overlay-header h2 {
    font-size: 18px;
  }
}

@media screen and (max-resolution: 0.8dppx) {
  /* Higher zoom levels */
  .content-header {
    flex-wrap: wrap;
  }
  
  /* Ensure pagination controls remain usable when zoomed */
  .pagination-controls {
    margin-top: 10px;
    flex-wrap: wrap;
  }
}

/* Additional zoom-specific styles for different screen sizes */
@media screen and (max-width: 768px) and (max-resolution: 1dppx) {
  /* This targets zoomed in mobile views */
  .table-container {
    padding-bottom: 10px; /* Add space for the scrollbar */
  }
  
  /* Ensure action buttons remain accessible when zoomed */
  .action-cell {
    padding: 10px 8px;
  }
}
/* Zoom-responsive styles using media queries based on zoom level */
@media (min-resolution: 96dpi) and (max-resolution: 119dpi) {
  /* 125% zoom level */
  .table-container {
    overflow-x: auto;
    padding-bottom: 15px; /* Space for scrollbar */
  }
  
  /* Apply iPad/tablet-like styling for tables when zoomed */
  .data-table th,
  .data-table td {
    padding: 12px 15px;
    font-size: 13px;
  }
  
  /* Action buttons adjustments matching iPad style */
  .action-cell {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .view-button, .checklist-button, .exam-button {
    max-width: 100% !important;

    margin: 2px 0;
    height: 38px;
    font-size: 12px;
    line-height: 38px;
  }
}

@media (min-resolution: 120dpi) and (max-resolution: 143dpi) {
  /* 150% zoom level */
  .table-container {
    overflow-x: auto;
    padding-bottom: 15px;
  }
  
  /* More compressed tablet/mobile styling */
  .data-table th,
  .data-table td {
    padding: 10px 12px;
    font-size: 12px;
  }
  
  .content-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .action-cell {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .view-button, .checklist-button, .exam-button {
    max-width: 100% !important;
    margin: 2px 0;
    height: 36px;
    font-size: 11px;
    line-height: 36px;
  }
}

@media (min-resolution: 144dpi) {
  /* 175%+ zoom level - full mobile styling */
  .table-container {
    overflow-x: auto;
    padding-bottom: 12px;
  }
  
  /* Apply mobile styling completely */
  .data-table th,
  .data-table td {
    padding: 8px 10px;
    font-size: 12px;
  }
  
  /* Content header matches mobile view */
  .content-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .content-header h1 {
    font-size: 20px;
  }
  
  /* Action buttons match mobile style */
  .action-cell {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
  }
  
  .view-button, .checklist-button, .exam-button {
    max-width: 100% !important;
    margin: 2px 0;
    height: 38px;
    font-size: 12px;
    line-height: 38px;
  }
  
  /* Search adjustments for high zoom */
  .search-container {
    min-width: 200px;
    max-width: 100%;
  }
  
  .search-input {
    padding: 8px 12px;
    padding-right: 30px;
    font-size: 12px;
  }
  
  .search-icon {
    right: 10px;
    font-size: 14px;
  }
  
  /* Pagination adjustments */
  .pagination-controls {
    flex-wrap: wrap;
    gap: 5px;
  }
}

/* Alternative zoom detection for browsers that don't fully support resolution queries */
@media screen and (max-width: 1350px) {
  /* This catches desktop screens when zoomed around 125-150% */
  body:not(.mobile-device):not(.tablet-device) .table-container {
    overflow-x: auto;
    padding-bottom: 15px;
  }
  
  body:not(.mobile-device):not(.tablet-device) .data-table th,
  body:not(.mobile-device):not(.tablet-device) .data-table td {
    padding: 12px 15px;
    font-size: 13px;
  }
  
  body:not(.mobile-device):not(.tablet-device) .action-cell {
    flex-direction: column;
    align-items: flex-start;
  }
  
  body:not(.mobile-device):not(.tablet-device) .view-button,
  body:not(.mobile-device):not(.tablet-device) .checklist-button,
  body:not(.mobile-device):not(.tablet-device) .exam-button {
    max-width: 100% !important;
    margin: 2px 0;
    height: 38px;
    font-size: 12px;
    line-height: 38px;
  }
}

@media screen and (max-width: 1100px) {
  /* This catches desktop screens when zoomed to around 175% or more */
  body:not(.mobile-device):not(.tablet-device) .content-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  body:not(.mobile-device):not(.tablet-device) .content-header h1 {
    font-size: 20px;
  }
  
  body:not(.mobile-device):not(.tablet-device) .data-table th,
  body:not(.mobile-device):not(.tablet-device) .data-table td {
    padding: 8px 10px;
    font-size: 12px;
  }
}

/* Filter Dropdown Styling */
.filter-dropdown {
  position: relative;
  width: auto; /* Changed from min-width: 150px */
  max-width: 200px; /* Added max-width limit */
  margin: 0 auto; /* Center the dropdown */
}


.filter-select {
  width: 100%;
  padding: 8px 30px 8px 10px; /* Reduced padding and adjusted for arrow space */
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  appearance: none;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px; /* Added to make the arrow icon smaller */
  cursor: pointer;
  transition: all 0.2s ease;
  text-overflow: ellipsis; /* Added to handle text overflow */
  white-space: nowrap; /* Keep text on one line */
  overflow: hidden; /* Hide overflow text */
}

.filter-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Make the content header more flexible for the filters */
.content-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}

.search-and-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* Responsive styling for filters */
@media screen and (max-width: 768px) {
  .content-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-and-filter {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-container, .filter-dropdown {
    width: 100%;
    margin-left: 0;
  }
}

/* Highlight filtered items with a subtle glow */
.filtered-item {
  position: relative;
}

.filtered-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.filtered-item:hover::after {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Admin Dashboard/Adboard.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,aAAa;EACb,6CAA6C;EAC7C,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB,EAAE,6CAA6C;AACrE;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,uBAAuB,EAAE,gBAAgB;EACzC,YAAY,EAAE,iBAAiB;EAC/B,iBAAiB,EAAE,2BAA2B;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc,EAAE,oBAAoB;EACpC,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,cAAc,EAAE,8BAA8B;EAC9C,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB,EAAE,+BAA+B;EACnD,OAAO,EAAE,+BAA+B;EACxC,eAAe,EAAE,yBAAyB;AAC5C;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;;AAGA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa,EAAE,oDAAoD;EACnE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;;;AAIA,+BAA+B;AAC/B;EACE,KAAK,2CAA2C,EAAE;EAClD,MAAM,4CAA4C,EAAE;EACpD,OAAO,yCAAyC,EAAE;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,UAAU;EACV,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE;IACE,WAAW,GAAG,0CAA0C;EAC1D;;EAEA;IACE,eAAe,GAAG,2BAA2B;EAC/C;;EAEA;IACE,aAAa,GAAG,mCAAmC;EACrD;;EAEA;IACE,eAAe,GAAG,uCAAuC;EAC3D;;EAEA;IACE,uBAAuB,GAAG,8BAA8B;IACxD,kBAAkB,GAAG,mBAAmB;EAC1C;;EAEA;IACE,uBAAuB,GAAG,uBAAuB;EACnD;;EAEA;IACE,eAAe,GAAG,4CAA4C;EAChE;;EAEA,iCAAiC;EACjC;IACE,gBAAgB,GAAG,mCAAmC;IACtD,WAAW,GAAG,8BAA8B;EAC9C;;EAEA;IACE,iBAAiB,GAAG,oBAAoB;IACxC,mBAAmB,GAAG,mCAAmC;IACzD,eAAe,GAAG,sBAAsB;EAC1C;;EAEA;IACE,WAAW,GAAG,yBAAyB;IACvC,eAAe,GAAG,sBAAsB;EAC1C;;EAEA,+BAA+B;EAC/B;IACE,sBAAsB,GAAG,+CAA+C;IACxE,uBAAuB,GAAG,kBAAkB;IAC5C,SAAS,GAAG,+BAA+B;EAC7C;;EAEA;IACE,eAAe,GAAG,oBAAoB;EACxC;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB,GAAG,yBAAyB;IAClD,aAAa;IACb,YAAY,GAAG,4BAA4B;IAC3C,eAAe,GAAG,iBAAiB;IACnC,iBAAiB,GAAG,qBAAqB;EAC3C;AACF;;AAEA,wCAAwC;AACxC;;EAEE;IACE,oBAAoB,EAAE,gCAAgC;EACxD;EACA;IACE,YAAY,GAAG,gDAAgD;EACjE;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe,GAAG,mCAAmC;IACrD,cAAc;EAChB;;EAEA;IACE,iBAAiB,GAAG,mBAAmB;EACzC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa,GAAG,6BAA6B;EAC/C;;EAEA,+BAA+B;EAC/B;;IAEE,kBAAkB,GAAG,oBAAoB;IACzC,eAAe,GAAG,0BAA0B;EAC9C;;EAEA,gEAAgE;EAChE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB,GAAG,eAAe;IACxC,aAAa;IACb,YAAY,GAAG,0BAA0B;IACzC,eAAe,GAAG,6BAA6B;IAC/C,iBAAiB,GAAG,qBAAqB;EAC3C;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,iCAAiC;EACjC;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;EACvB;IACE,eAAe;EACjB;;EAEA,yDAAyD;EACzD;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,+DAA+D;AAC/D;EACE,wCAAwC;EACxC;IACE,oBAAoB,EAAE,gCAAgC;EACxD;;EAEA,wDAAwD;EACxD;IACE,iBAAiB;EACnB;AACF;AACA,mEAAmE;AACnE;EACE,oBAAoB;EACpB;IACE,gBAAgB;IAChB,oBAAoB,EAAE,wBAAwB;EAChD;;EAEA,0DAA0D;EAC1D;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,mDAAmD;EACnD;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;;IAE1B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,oBAAoB;EACpB;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,0CAA0C;EAC1C;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,2CAA2C;EAC3C;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,oCAAoC;EACpC;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,uCAAuC;EACvC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,eAAe;IACf,QAAQ;EACV;AACF;;AAEA,wFAAwF;AACxF;EACE,6DAA6D;EAC7D;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,oEAAoE;EACpE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW,EAAE,kCAAkC;EAC/C,gBAAgB,EAAE,0BAA0B;EAC5C,cAAc,EAAE,wBAAwB;AAC1C;;;AAGA;EACE,WAAW;EACX,0BAA0B,EAAE,iDAAiD;EAC7E,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yDAA8R;EAC9R,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB,EAAE,yCAAyC;EAChE,eAAe;EACf,yBAAyB;EACzB,uBAAuB,EAAE,kCAAkC;EAC3D,mBAAmB,EAAE,0BAA0B;EAC/C,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,6CAA6C;EAC7C,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* Main Dashboard Layout */\r\n.dashboard-container {\r\n  display: flex;\r\n  height: 100vh;\r\n  font-family: 'Roboto', 'Segoe UI', sans-serif;\r\n  background-color: #f7f9fc;\r\n  color: #333;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Error Banner */\r\n.error-banner {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  background-color: #f44336;\r\n  color: white;\r\n  padding: 12px 20px;\r\n  text-align: center;\r\n  font-weight: 500;\r\n  z-index: 9999;\r\n  animation: slideDown 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideDown {\r\n  from { transform: translateY(-100%); }\r\n  to { transform: translateY(0); }\r\n}\r\n\r\n/* Loading Animation */\r\n.loading-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  background-color: #f7f9fc;\r\n}\r\n\r\n.loading-spinner {\r\n  position: relative;\r\n  width: 60px;\r\n  height: 60px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.spinner {\r\n  width: 60px;\r\n  height: 60px;\r\n  border: 6px solid rgba(124, 193, 51, 0.2);\r\n  border-radius: 50%;\r\n  border-top-color: #7CC133;\r\n  animation: spin 1.5s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.loading-container p {\r\n  color: #555;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Sidebar Styling */\r\n.sidebar {\r\n  width: 250px;\r\n  background: linear-gradient(145deg, #1e3a8a, #304da6);\r\n  color: white;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\r\n  z-index: 100;\r\n  transition: width 0.3s ease;\r\n  overflow-y: auto;\r\n}\r\n\r\n.logo-container {\r\n  padding: 25px 20px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.sidebar .logo {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  margin: 0;\r\n  letter-spacing: 0.5px;\r\n  color: white;\r\n}\r\n\r\n.sidebar-nav {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  padding: 20px 0;\r\n}\r\n\r\n.sidebar-nav ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.nav-item {\r\n  padding: 14px 20px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: all 0.2s ease;\r\n  border-left: 4px solid transparent;\r\n}\r\n\r\n.nav-item:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.nav-item.active {\r\n  background-color: rgba(255, 255, 255, 0.15);\r\n  border-left-color: #7cc133;\r\n}\r\n\r\n.nav-icon {\r\n  margin-right: 12px;\r\n  font-size: 18px;\r\n  width: 24px;\r\n  text-align: center;\r\n}\r\n\r\n.nav-text {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n}\r\n\r\n.sidebar-footer {\r\n  padding: 20px;\r\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.logout-button {\r\n  width: 100%;\r\n  padding: 12px 0;\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.logout-button:hover {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.logout-icon {\r\n  margin-right: 8px;\r\n  font-size: 16px;\r\n}\r\n\r\n/* Main Content Area */\r\n.main-content {\r\n  flex: 1;\r\n  padding: 30px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 25px;\r\n}\r\n\r\n.content-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.content-header h1 {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin: 0;\r\n}\r\n\r\n/* Search Bar */\r\n.search-container {\r\n  position: relative;\r\n  min-width: 300px;\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  padding: 10px 15px;\r\n  padding-right: 40px;\r\n  border-radius: 8px;\r\n  border: 1px solid #e0e0e0;\r\n  font-size: 14px;\r\n  transition: all 0.2s ease;\r\n  background-color: #fff;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #888;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Data Card Styling */\r\n.data-card {\r\n  background-color: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.card-header {\r\n  padding: 20px 25px;\r\n  border-bottom: 1px solid #eaedf2;\r\n}\r\n\r\n.card-header h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.table-responsive {\r\n  overflow-x: auto;\r\n  padding-bottom: 10px; /* Add padding to prevent cut-off at bottom */\r\n}\r\n\r\n/* Data Table Styling */\r\n.data-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.data-table thead tr {\r\n  background-color: #f8f9fd;\r\n}\r\n\r\n.data-table th {\r\n  padding: 15px 20px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  border-bottom: 1px solid #eaedf2;\r\n}\r\n\r\n.data-table td {\r\n  padding: 15px 20px;\r\n  border-bottom: 1px solid #eaedf2;\r\n  color: #333;\r\n}\r\n\r\n.data-table tbody tr {\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.data-table tbody tr:hover {\r\n  background-color: #f8f9fd;\r\n}\r\n\r\n.no-results {\r\n  text-align: center;\r\n  padding: 30px;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n/* Role Badge */\r\n.role-badge {\r\n  display: inline-block;\r\n  padding: 5px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  background-color: #e0f2ff;\r\n  color: #0077cc;\r\n}\r\n\r\n/* Status Badges */\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 5px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  margin-right: 10px;\r\n}\r\n\r\n.status-pending {\r\n  background-color: #fff8e0;\r\n  color: #f59e0b;\r\n}\r\n\r\n.status-approved {\r\n  background-color: #ecfdf5;\r\n  color: #10b981;\r\n}\r\n\r\n.status-rejected {\r\n  background-color: #fef2f2;\r\n  color: #ef4444;\r\n}\r\n\r\n.status-passed {\r\n  background-color: #ecfdf5;\r\n  color: #10b981;\r\n}\r\n\r\n.status-failed {\r\n  background-color: #fef2f2;\r\n  color: #ef4444;\r\n}\r\n\r\n/* Action Buttons */\r\n\r\n.action-cell {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: flex-start; \r\n}\r\n\r\n.view-button, .checklist-button, .exam-button {\r\n  display: inline-block;\r\n  margin: 2px;\r\n  width: 130px !important; /* Fixed width */\r\n  height: 45px; /* Fixed height */\r\n  line-height: 36px; /* Center text vertically */\r\n  text-align: center;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  padding: 0 5px; /* Reduced padding */\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.view-button {\r\n  background-color: #e0f2ff;\r\n  color: #0077cc;\r\n}\r\n\r\n.view-button:hover {\r\n  background-color: #d0e9ff;\r\n}\r\n\r\n.close-button {\r\n  background-color: #f1f5f9;\r\n  color: #64748b;\r\n}\r\n\r\n.close-button:hover {\r\n  background-color: #e2e8f0;\r\n}\r\n\r\n.checklist-button {\r\n  background-color: #fef9c3;\r\n  color: #d97706;\r\n}\r\n\r\n.checklist-button:hover {\r\n  background-color: #fef3c7;\r\n}\r\n\r\n.exam-button {\r\n  background-color: #e0e7ff;\r\n  color: #4f46e5;\r\n}\r\n\r\n.exam-button:hover {\r\n  background-color: #d1d9ff;\r\n}\r\n\r\n.info-button {\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n  border-radius: 50%;\r\n  background-color: #f1f5f9;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.info-button:hover {\r\n  background-color: #e2e8f0;\r\n}\r\n\r\n/* Modal Styling */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  backdrop-filter: blur(3px);\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n.modal-container {\r\n  background-color: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 600px;\r\n  max-height: 90vh;\r\n  margin: 0 auto; /* This helps with centering */\r\n  overflow-y: auto;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n  animation: slideUp 0.3s ease-out;\r\n  position: relative; /* Ensure positioning context */\r\n  left: 0; /* Reset any left positioning */\r\n  transform: none; /* Reset any transforms */\r\n}\r\n\r\n@keyframes slideUp {\r\n  from { transform: translateY(30px); opacity: 0; }\r\n  to { transform: translateY(0); opacity: 1; }\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 25px;\r\n  border-bottom: 1px solid #eaedf2;\r\n}\r\n\r\n.modal-header h2 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.modal-close-button {\r\n  background: none;\r\n  border: none;\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 24px;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.modal-close-button:hover {\r\n  background-color: #f1f5f9;\r\n}\r\n\r\n.modal-body {\r\n  padding: 25px;\r\n}\r\n\r\n.detail-grid {\r\n  display: grid;\r\n  gap: 16px;\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  border-bottom: 1px solid #f1f5f9;\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.detail-label {\r\n  min-width: 120px;\r\n  font-weight: 600;\r\n  color: #64748b;\r\n}\r\n\r\n.detail-value {\r\n  flex: 1;\r\n  color: #333;\r\n}\r\n\r\n\r\n/* Document Overlay Fix */\r\n.document-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  backdrop-filter: blur(3px);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n.document-overlay-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 900px;\r\n  height: 90vh;\r\n  overflow: auto;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n  position: relative;\r\n  z-index: 1001; /* Ensure content appears above overlay background */\r\n  animation: slideUp 0.3s ease-out;\r\n}\r\n\r\n.document-overlay-close-button {\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 15px;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  background-color: white;\r\n  border: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 24px;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1002;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.document-overlay-close-button:hover {\r\n  background-color: #f1f5f9;\r\n}\r\n\r\n.document-overlay-header {\r\n  padding: 25px;\r\n  border-bottom: 1px solid #eaedf2;\r\n}\r\n\r\n.document-overlay-header h2 {\r\n  margin: 0 0 8px 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.document-overlay-header p {\r\n  margin: 0;\r\n  color: #64748b;\r\n  font-size: 14px;\r\n}\r\n\r\n.document-content-wrapper {\r\n  padding: 20px;\r\n  overflow: auto;\r\n}\r\n\r\n/* Print styles for document overlay */\r\n@media print {\r\n  @page {\r\n    size: auto; \r\n    margin: 0; \r\n  }\r\n  \r\n  .dashboard-container, .sidebar, .main-content {\r\n    display: none;\r\n  }\r\n  \r\n  body {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n  \r\n  body * {\r\n    visibility: hidden;\r\n  }\r\n  \r\n  .document-overlay-content, .document-overlay-content * {\r\n    visibility: visible;\r\n  }\r\n  \r\n  .document-overlay-content {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: auto;\r\n    max-width: none;\r\n    box-shadow: none;\r\n    overflow: visible;\r\n    background: none;\r\n    border-radius: 0;\r\n    padding: 0;\r\n  }\r\n\r\n  .document-overlay-close-button, .document-overlay-header {\r\n    display: none; \r\n  }\r\n}\r\n\r\n\r\n\r\n/* Animations for UI elements */\r\n@keyframes pulseGlow {\r\n  0% { box-shadow: 0 0 0 0 rgba(124, 193, 51, 0.4); }\r\n  70% { box-shadow: 0 0 0 10px rgba(124, 193, 51, 0); }\r\n  100% { box-shadow: 0 0 0 0 rgba(124, 193, 51, 0); }\r\n}\r\n\r\n.role-badge {\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n.status-badge {\r\n  animation: fadeIn 0.5s ease-out;\r\n}\r\n\r\n/* Override for conflicting close-button class */\r\n.action-button.close-button {\r\n  background-color: #f1f5f9;\r\n  color: #64748b;\r\n}\r\n\r\n.action-button.close-button:hover {\r\n  background-color: #e2e8f0;\r\n}\r\n\r\n/* Subtle hover effects for rows */\r\n.data-table tbody tr {\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.data-table tbody tr:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n  z-index: 1;\r\n  position: relative;\r\n}\r\n\r\n/* Add this media query at the bottom of your CSS file */\r\n@media screen and (max-width: 768px) {\r\n  .sidebar {\r\n    width: 70px;  /* Reduce sidebar width on small screens */\r\n  }\r\n \r\n  .sidebar .logo {\r\n    font-size: 16px;  /* Make logo text smaller */\r\n  }\r\n \r\n  .nav-text {\r\n    display: none;  /* Hide nav text on small screens */\r\n  }\r\n \r\n  .nav-icon {\r\n    margin-right: 0;  /* Remove margin since text is hidden */\r\n  }\r\n \r\n  .nav-item {\r\n    justify-content: center;  /* Center the remaining icon */\r\n    padding: 14px 10px;  /* Reduce padding */\r\n  }\r\n \r\n  .logout-button {\r\n    justify-content: center;  /* Center logout icon */\r\n  }\r\n \r\n  .logout-icon {\r\n    margin-right: 0;  /* Remove margin since text will be hidden */\r\n  }\r\n  \r\n  /* Search container adjustments */\r\n  .search-container {\r\n    min-width: 200px;  /* Reduce minimum width on mobile */\r\n    width: 100%;  /* Allow it to be responsive */\r\n  }\r\n \r\n  .search-input {\r\n    padding: 8px 12px;  /* Smaller padding */\r\n    padding-right: 30px;  /* Maintain space for search icon */\r\n    font-size: 12px;  /* Smaller font size */\r\n  }\r\n \r\n  .search-icon {\r\n    right: 10px;  /* Adjust icon position */\r\n    font-size: 14px;  /* Smaller icon size */\r\n  }\r\n \r\n  /* Content header adjustments */\r\n  .content-header {\r\n    flex-direction: column;  /* Stack elements vertically on small screens */\r\n    align-items: flex-start;  /* Align to left */\r\n    gap: 15px;  /* Add space between elements */\r\n  }\r\n \r\n  .content-header h1 {\r\n    font-size: 20px;  /* Smaller heading */\r\n  }\r\n  \r\n  /* Action buttons for mobile view */\r\n  .action-cell {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .view-button, .checklist-button, .exam-button {\r\n    width: 100% !important;  /* Full width on mobile */\r\n    margin: 2px 0;\r\n    height: 38px;  /* Slightly smaller height */\r\n    font-size: 12px;  /* Smaller font */\r\n    line-height: 38px;  /* Match the height */\r\n  }\r\n}\r\n\r\n/* Media query for iPad/tablet devices */\r\n@media screen and (min-width: 769px) and (max-width: 1024px) {\r\n\r\n  .table-container {\r\n    padding-bottom: 12px; /* Add space for the scrollbar */\r\n  }\r\n  .sidebar {\r\n    width: 180px;  /* Wider than mobile but narrower than desktop */\r\n  }\r\n \r\n  .sidebar .logo {\r\n    font-size: 18px;\r\n  }\r\n \r\n  .nav-text {\r\n    font-size: 14px;  /* Smaller text but still visible */\r\n    display: block;\r\n  }\r\n \r\n  .nav-icon {\r\n    margin-right: 8px;  /* Reduced margin */\r\n  }\r\n \r\n  .nav-item {\r\n    padding: 12px 15px;\r\n  }\r\n \r\n  .search-container {\r\n    min-width: 250px;\r\n  }\r\n \r\n  .main-content {\r\n    padding: 20px;  /* Slightly reduced padding */\r\n  }\r\n \r\n  /* Table adjustments for iPad */\r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 12px 15px;  /* Reduced padding */\r\n    font-size: 13px;  /* Slightly smaller font */\r\n  }\r\n \r\n  /* Action buttons adjustments for iPad - MATCHING MOBILE STYLE */\r\n  .action-cell {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .view-button, .checklist-button, .exam-button {\r\n    width: 100% !important;  /* Full width */\r\n    margin: 2px 0;\r\n    height: 38px;  /* Same height as mobile */\r\n    font-size: 12px;  /* Same font size as mobile */\r\n    line-height: 38px;  /* Match the height */\r\n  }\r\n \r\n  /* Modal adjustments */\r\n  .modal-container {\r\n    max-width: 550px;\r\n  }\r\n \r\n  .modal-body {\r\n    padding: 20px;\r\n  }\r\n \r\n  /* Document overlay adjustments */\r\n  .document-overlay-content {\r\n    max-width: 800px;\r\n  }\r\n \r\n  .document-overlay-header {\r\n    padding: 20px;\r\n  }\r\n \r\n  .document-overlay-header h2 {\r\n    font-size: 18px;\r\n  }\r\n}\r\n\r\n@media screen and (max-resolution: 0.8dppx) {\r\n  /* Higher zoom levels */\r\n  .content-header {\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  /* Ensure pagination controls remain usable when zoomed */\r\n  .pagination-controls {\r\n    margin-top: 10px;\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n/* Additional zoom-specific styles for different screen sizes */\r\n@media screen and (max-width: 768px) and (max-resolution: 1dppx) {\r\n  /* This targets zoomed in mobile views */\r\n  .table-container {\r\n    padding-bottom: 10px; /* Add space for the scrollbar */\r\n  }\r\n  \r\n  /* Ensure action buttons remain accessible when zoomed */\r\n  .action-cell {\r\n    padding: 10px 8px;\r\n  }\r\n}\r\n/* Zoom-responsive styles using media queries based on zoom level */\r\n@media (min-resolution: 96dpi) and (max-resolution: 119dpi) {\r\n  /* 125% zoom level */\r\n  .table-container {\r\n    overflow-x: auto;\r\n    padding-bottom: 15px; /* Space for scrollbar */\r\n  }\r\n  \r\n  /* Apply iPad/tablet-like styling for tables when zoomed */\r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 12px 15px;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  /* Action buttons adjustments matching iPad style */\r\n  .action-cell {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .view-button, .checklist-button, .exam-button {\r\n    max-width: 100% !important;\r\n\r\n    margin: 2px 0;\r\n    height: 38px;\r\n    font-size: 12px;\r\n    line-height: 38px;\r\n  }\r\n}\r\n\r\n@media (min-resolution: 120dpi) and (max-resolution: 143dpi) {\r\n  /* 150% zoom level */\r\n  .table-container {\r\n    overflow-x: auto;\r\n    padding-bottom: 15px;\r\n  }\r\n  \r\n  /* More compressed tablet/mobile styling */\r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 10px 12px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .content-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .action-cell {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .view-button, .checklist-button, .exam-button {\r\n    max-width: 100% !important;\r\n    margin: 2px 0;\r\n    height: 36px;\r\n    font-size: 11px;\r\n    line-height: 36px;\r\n  }\r\n}\r\n\r\n@media (min-resolution: 144dpi) {\r\n  /* 175%+ zoom level - full mobile styling */\r\n  .table-container {\r\n    overflow-x: auto;\r\n    padding-bottom: 12px;\r\n  }\r\n  \r\n  /* Apply mobile styling completely */\r\n  .data-table th,\r\n  .data-table td {\r\n    padding: 8px 10px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  /* Content header matches mobile view */\r\n  .content-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .content-header h1 {\r\n    font-size: 20px;\r\n  }\r\n  \r\n  /* Action buttons match mobile style */\r\n  .action-cell {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .view-button, .checklist-button, .exam-button {\r\n    max-width: 100% !important;\r\n    margin: 2px 0;\r\n    height: 38px;\r\n    font-size: 12px;\r\n    line-height: 38px;\r\n  }\r\n  \r\n  /* Search adjustments for high zoom */\r\n  .search-container {\r\n    min-width: 200px;\r\n    max-width: 100%;\r\n  }\r\n  \r\n  .search-input {\r\n    padding: 8px 12px;\r\n    padding-right: 30px;\r\n    font-size: 12px;\r\n  }\r\n  \r\n  .search-icon {\r\n    right: 10px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Pagination adjustments */\r\n  .pagination-controls {\r\n    flex-wrap: wrap;\r\n    gap: 5px;\r\n  }\r\n}\r\n\r\n/* Alternative zoom detection for browsers that don't fully support resolution queries */\r\n@media screen and (max-width: 1350px) {\r\n  /* This catches desktop screens when zoomed around 125-150% */\r\n  body:not(.mobile-device):not(.tablet-device) .table-container {\r\n    overflow-x: auto;\r\n    padding-bottom: 15px;\r\n  }\r\n  \r\n  body:not(.mobile-device):not(.tablet-device) .data-table th,\r\n  body:not(.mobile-device):not(.tablet-device) .data-table td {\r\n    padding: 12px 15px;\r\n    font-size: 13px;\r\n  }\r\n  \r\n  body:not(.mobile-device):not(.tablet-device) .action-cell {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  body:not(.mobile-device):not(.tablet-device) .view-button,\r\n  body:not(.mobile-device):not(.tablet-device) .checklist-button,\r\n  body:not(.mobile-device):not(.tablet-device) .exam-button {\r\n    max-width: 100% !important;\r\n    margin: 2px 0;\r\n    height: 38px;\r\n    font-size: 12px;\r\n    line-height: 38px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  /* This catches desktop screens when zoomed to around 175% or more */\r\n  body:not(.mobile-device):not(.tablet-device) .content-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n  \r\n  body:not(.mobile-device):not(.tablet-device) .content-header h1 {\r\n    font-size: 20px;\r\n  }\r\n  \r\n  body:not(.mobile-device):not(.tablet-device) .data-table th,\r\n  body:not(.mobile-device):not(.tablet-device) .data-table td {\r\n    padding: 8px 10px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n/* Filter Dropdown Styling */\r\n.filter-dropdown {\r\n  position: relative;\r\n  width: auto; /* Changed from min-width: 150px */\r\n  max-width: 200px; /* Added max-width limit */\r\n  margin: 0 auto; /* Center the dropdown */\r\n}\r\n\r\n\r\n.filter-select {\r\n  width: 100%;\r\n  padding: 8px 30px 8px 10px; /* Reduced padding and adjusted for arrow space */\r\n  border-radius: 8px;\r\n  border: 1px solid #e0e0e0;\r\n  font-size: 14px;\r\n  appearance: none;\r\n  background-color: #fff;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\r\n  background-repeat: no-repeat;\r\n  background-position: right 8px center;\r\n  background-size: 12px; /* Added to make the arrow icon smaller */\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-overflow: ellipsis; /* Added to handle text overflow */\r\n  white-space: nowrap; /* Keep text on one line */\r\n  overflow: hidden; /* Hide overflow text */\r\n}\r\n\r\n.filter-select:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n/* Make the content header more flexible for the filters */\r\n.content-header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.search-and-filter {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Responsive styling for filters */\r\n@media screen and (max-width: 768px) {\r\n  .content-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .search-and-filter {\r\n    width: 100%;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  \r\n  .search-container, .filter-dropdown {\r\n    width: 100%;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n/* Highlight filtered items with a subtle glow */\r\n.filtered-item {\r\n  position: relative;\r\n}\r\n\r\n.filtered-item::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  border-radius: 4px;\r\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3);\r\n  pointer-events: none;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n}\r\n\r\n.filtered-item:hover::after {\r\n  opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
